import {
  ResolvedButtonElement,
  ResolvedCUEElement,
} from "@app/layouts/Article/elements";
import styles from "@app/layouts/Article/Storyline.module.css";
import { Button } from "@sphtech/dmg-design-system";
import { getGeniusLink } from "@src/app/utils/trackers/skimlinks";

type AppendedGalleryItemProps = {
  galleryItem: ResolvedCUEElement;
  buttonVariant?: "primary" | "secondary" | "tertiary";
};

/**
 * Logic copied from Gallery.tsx L112-L135
 */
const AppendedGalleryItem = ({
  galleryItem,
  buttonVariant,
}: AppendedGalleryItemProps) => {
  if (
    galleryItem.type === "call_to_action" ||
    galleryItem.type === "shop_button"
  ) {
    const cta =
      galleryItem.type === "call_to_action" && galleryItem.children
        ? (galleryItem.children[0] as ResolvedButtonElement)
        : galleryItem;

    const addtionalFields = cta.additionalFields;

    return (
      <span className={styles.buttonInlineWrapper}>
        <Button
          variant={buttonVariant || "secondary"}
          href={getGeniusLink(
            addtionalFields.destinationUrl?.value ??
              addtionalFields.websiteLink?.value ??
              "",
          )}
          target="_blank"
        >
          {addtionalFields.textToDisplay?.value ?? addtionalFields.name?.value}
        </Button>
      </span>
    );
  }

  return null;
};

export default AppendedGalleryItem;
